import { render, staticRenderFns } from "./ModelCategory.vue?vue&type=template&id=5d2a026f&scoped=true&"
import script from "./ModelCategory.vue?vue&type=script&lang=js&"
export * from "./ModelCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a026f",
  null
  
)

export default component.exports